/**
 * 统一 API 客户端
 */
import { ToastManager } from '../ui/ToastManager';

export interface ApiResponse<T = any> {
    code: number;
    message: string;
    data: T;
}

export class ApiClient {
    private static async request<T>(path: string, options: RequestInit & { skipErrorToast?: boolean } = {}): Promise<T> {
        const url = path.startsWith('http') ? path : `${path}`;
        const { skipErrorToast, ...fetchOptions } = options;
        
        const defaultOptions: RequestInit = {
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers,
            },
        };

        const response = await fetch(url, defaultOptions);
        
        if (response.status === 401) {
            // 静默处理未登录情况
        }
        
        // Handle server errors (500)
        if (response.status >= 500) {
            const errorMsg = 'Server Error';
            if (!skipErrorToast) ToastManager.error(errorMsg);
            throw new Error(errorMsg);
        }

        const result: ApiResponse<T> = await response.json();

        // Handle logical errors (code != 0)
        if (result.code !== 0) {
            const errorMsg = result.message || 'Request failed';
            if (!skipErrorToast) ToastManager.error(errorMsg);
            // Throw error to break the promise chain in caller
            throw new Error(errorMsg);
        }

        return result.data;
    }

    static get<T>(path: string, params?: Record<string, string>, options: { skipErrorToast?: boolean } = {}) {
        const url = new URL(path, window.location.origin);
        if (params) {
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        }
        return this.request<T>(url.toString(), { method: 'GET', ...options });
    }

    static post<T>(path: string, data: any, options: { skipErrorToast?: boolean } = {}) {
        return this.request<T>(path, {
            method: 'POST',
            body: JSON.stringify(data),
            ...options
        });
    }

    /**
     * Google 登录跳转
     */
    static loginWithGoogle() {
        window.location.href = '/api/auth/google/redirect';
    }
}
